import objectPath from 'object-path'

const getRuleColorLabelTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

export const onRuleColorLabel = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleColorLabelTarget(action, target)
  if (!targetKey) return undefined

  let { labelColor, warningColor } = action
  objectPath.set(isUiChanged, `isChangeColor.${targetKey}`, {
    labelColor,
    warningColor,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    labelColor,
    warningColor,
  }
}
